<template>
  <div class="relation_left_info">
    <dl>
      <dt>绿盟平台 申请使用您的</dt>
      <dd>头像、昵称信息</dd>
    </dl>
    <div class="login_three_img">
      <img v-if="info.headimgurl !== ''" :src="info.headimgurl" alt="微信头像">
      <img v-else src="http://cms.greenglga.com/default.jpg" alt="微信头像">
    </div>
    <p class="login_three_name">
      {{info.nickname}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'relationLeftIfo',
  props: {
    info: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>
